<template>
   <v-text-field :label="label" :value="longFormat" ref="textbox" style="width:100%" 
    @change="changed" :hide-details="hideDetails" :single-line="singleLine" :class="{'compact-element': compact}"/>
</template>

<script>

// 
import StringHelpers from '../helpers/StringHelpers'
import NumberHelpers from '../helpers/NumberHelpers'


export default {
    data() {
        return {
    
        }
    },
    
    props: {
        label: String,
        value: [String, Number],
        hideDetails: Boolean,
        singleLine: Boolean,
        compact: Boolean
    },

    computed: {
        longFormat() {
            return StringHelpers.formatCurrencyWithCents(this.value)
        },
        shortFormat() {
            return StringHelpers.formatFloat(this.value)
        } 
    },

    methods: {


        inputted(val) {
            this.$emit('input', val)
        },
        
        changed(val) {
            val = this.convertToRawNumber(val)
            
            this.$emit('input', val) 
            this.$emit('change')

            // return true
        },


        convertToRawNumber(val) {
            if(val == '')
                return ''

            val = val.toLowerCase()

            let multiplier = 1

            if(val.indexOf('m') > -1)
                multiplier = 1000000
            else if(val.indexOf('k') > -1)
                multiplier = 1000

            val = NumberHelpers.numbersFromString(val)

            if(!val)
                val = 0

            val = val * multiplier

            return val
        },

    }
}
</script>

<style scoped>
    .input-group--text-field.compact-element {
        margin-top: -18px; margin-bottom: 0px
    }   
</style>




// WEBPACK FOOTER //
// CurrencyBox.vue?516c2a64